<template>
    <div class="payments">
      <section id="paymentOptions">
        <div class="info">
          {{feeErrorMessage}}
        </div>
        <div v-if="feesLoaded">
          <h2 class="payment-title">{{returnTitle}}</h2>
          <div class="info" v-html="paymentOptionsInfo"></div>
          <div :class="[ isMobile ? 'new-options-mobile' : '', 'new-options']">
            <div v-for="option in paymentOptionsDisplay" :key="option.PaymentMethod" :style="option.displayOrder()">
              <PaymentOption :paymentOption="option" @option-selected="selectOption"></PaymentOption>
            </div>
          </div>
          <div class="disclaimer-container" v-if="!getInsurance.optedOutOfPli">
            <span class="iptDisclaimer disclaimer">{{iptDisclaimer}}</span>
          </div>
          <div v-if="allPaymentOptionsAvailable" class="disclaimer-container">
            <span class="asterisk">*</span><span class="disclaimer">{{disclaimer}}</span>
          </div>
        </div>
      </section>
    </div>
</template>

<script>
import {
  mapActions, mapGetters, mapState, mapMutations,
} from 'vuex';
import analytics from '../ga';
import Manager from '../applicationManager';
import PaymentOption from './PaymentOption.vue';
// TODO compare correctly with Salesforce and current dev to work out what to use
export default {
  name: 'PaymentOptions',
  async created() {
    const result = await this.getCurrentFees();

    this.feesLoaded = result.isSuccessful;
    this.feeErrorMessage = this.feesLoaded ? '' : result.message;
  },
  components: {
    PaymentOption,
  },
  data() {
    return {
      disclaimer: 'All the normal safeguards and guarantees still apply. No changes to the amount,'
      + 'date or frequency can be made without notifying you at least 10 working days in advance of your account being debited.'
      + 'In the event of any error, you are entitled to a full and immediate refund from your bank or building society. '
      + 'You have the right to cancel your Direct Debit Instruction at any time simply by writing to your bank'
      + ' or building society with a copy to us.',
      feesLoaded: false,
      feeErrorMessage: 'Calculating the membership fees',
      sections: {
        paymentOptions: { tab: this.$store.state.isMobile ? -1 : 0 },
      },
      iptDisclaimer: 'Prices include Insurance Premium Tax (IPT) charged at the appropriate rate.',
    };
  },
  methods: {
    ...mapActions(['getCurrentFees']),
    ...mapMutations(['savePaymentOption']),
    async selectOption(option) {
      this.savePaymentOption(option);
      await Manager.setPaymentOption(option);

      if (this.allPaymentOptionsAvailable) {
        analytics.sendDDGuarantee(this.application.Type);
      }
      this.$emit('completed');
    },
  },
  computed: {
    ...mapGetters(['returnTitle', 'allPaymentOptionsAvailable', 'paymentOptionsInfo', 'paymentOptionsDisplay', 'getInsurance']),
    ...mapState(['isMobile', 'application']),
  },
};
</script>

<style lang="scss">
  @import '../styles/_mixins.scss';

  .payments {
    width: 100% !important;
    @include DefaultPoppinFont();

    .new-options {
      display: flex;
      justify-content: space-around;

      > div {
        flex-grow: 1;
        margin: 0 2%;
      }
    }

    .new-options-mobile {
      flex-flow: column;
    }

    .new-options ~ .disclaimer-container, .new-options-mobile ~ .disclaimer-container {
      display: flex;
      padding: 2% 11%;
      background: #F6F1ED;

      span.asterisk {
        @include DefaultPoppinFont();
      }

      span.disclaimer {
        text-align: justify;
        font-size: 12pt;
        @include DefaultPoppinFont();
      }
    }

    .payment-title {
      @include DefaultBerlinskeFont();
      text-align:center;
    }

    .discount-info {
      background-color: #e2f0e2;
      padding: 1.7%;
      margin-bottom: 40px;
      color: #2f690e;
    }

    .info {
      margin-bottom: 20px;
    }
  }
</style>
